import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { SelectButton, Dropdown } from "@weezevent/nacre";
import classes from "./attendees-batch-actions.module.scss";
import { BatchActionsModals } from "./components/batch-actions-modals";
import { ActionsTypes } from "./constants";

const AttendeesBatchActions = ({ attendeeIds, onSuccess, eventId }) => {
	const { t } = useTranslation();
	const { length: count } = attendeeIds;
	const [openedModal, setOpenedModal] = React.useState(null);

	const title = React.useMemo(() => {
		if (count === 0) {
			return t("access.attendees.attendeesList.batchActions.noAction");
		}
		if (count === 1) {
			return t("access.attendees.attendeesList.batchActions.oneSelected");
		}
		return t("access.attendees.attendeesList.batchActions.selected", {
			count
		});
	}, [count, t]);

	const handleSuccessBatchAction = () => {
		setOpenedModal(null);
		onSuccess();
	};

	return (
		<>
			<BatchActionsModals
				openedType={openedModal}
				onCancel={() => setOpenedModal(null)}
				onSuccess={handleSuccessBatchAction}
				attendeeIds={attendeeIds}
				eventId={eventId}
			/>
			<SelectButton
				tooltipTitle={t(
					"access.attendees.attendeesList.batchActions.noActionTooltip"
				)}
				title={title}
				objects={attendeeIds}
			>
				<span className={classes.title}>
					{t(
						"access.attendees.attendeesList.batchActions.BatchActionsLabel"
					)}
				</span>
				<Dropdown.Item
					key="1.0"
					onClick={() => setOpenedModal(ActionsTypes.ADD_RIGHTS)}
					item={t(
						"access.attendees.attendeesList.batchActions.AddRightsLabel"
					)}
				/>
				<Dropdown.Item
					key="1.1"
					onClick={() => setOpenedModal(ActionsTypes.REMOVE_RIGHTS)}
					item={t(
						"access.attendees.attendeesList.batchActions.RemoveRightsLabel"
					)}
				/>
			</SelectButton>
		</>
	);
};

AttendeesBatchActions.propTypes = {
	attendeeIds: PropTypes.arrayOf(PropTypes.number),
	onSuccess: PropTypes.func
};

AttendeesBatchActions.defaultProps = {
	attendeeIds: [],
	onSuccess: () => {}
};
export default AttendeesBatchActions;
